// src/components/multi-listing-ad/multi-listing-ad.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment MultiListingAdCallToActionFragment on SponsoredContentMultiListingAd {\n    callToAction(context: $context, searchCriteriaInput: $searchCriteriaInput) {\n      text\n      action {\n        accessibility\n        resource {\n          value\n        }\n        target\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment MultiListingAdCarouselFragment on SponsoredContentMultiListingAd {\n    brandProperties(context: $context, searchCriteriaInput: $searchCriteriaInput) {\n      ...LodgingCardFragment\n    }\n    carouselAnalytics {\n      linkName\n      referrerId\n    }\n  }\n\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment MultiListingAdHeadFragment on SponsoredContentMultiListingAd {\n    paragraph\n    logo {\n      standard {\n        url {\n          value\n        }\n        description\n        size\n      }\n    }\n    badge {\n      accessibility\n      text\n    }\n    adTransparencyTrigger {\n      adTransparencyId\n      adTransparencyButton {\n        ...AdTransparencyButtonFragment\n      }\n      adTransparencyOverlaySkeleton {\n        ...TransparencyOverlaySkeletonFragment\n      }\n    }\n    heading\n    callToAction(context: $context, searchCriteriaInput: $searchCriteriaInput) {\n      action {\n        target\n        accessibility\n        resource {\n          value\n        }\n        analytics {\n          linkName\n          referrerId\n        }\n      }\n    }\n  }\n\n  fragment AdTransparencyButtonFragment on AdTransparencyButton {\n    __typename\n    primary\n    accessibility\n    disabled\n    icon {\n      description\n      id\n      title\n    }\n    analyticsPayload\n  }\n  fragment TransparencyOverlaySkeletonFragment on TransparencyOverlaySkeleton {\n    title\n    error {\n      icon {\n        id\n        size\n      }\n      description\n      button {\n        primary\n      }\n      allowedRetryAttempts\n      exceededAttemptsMessage\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  query MultiListingAdQuery(\n    $context: ContextInput!\n    $sponsoredContentContextInput: SponsoredContentContextInput!\n    $searchCriteriaInput: MultiItemSearchContextInput!\n  ) {\n    sponsoredContent {\n      multiListingAd(context: $context, searchCriteriaInput: $searchCriteriaInput, sponsoredContentContextInput: $sponsoredContentContextInput) {\n        ...MultiListingAdHeadFragment\n        ...MultiListingAdCarouselFragment\n        ...MultiListingAdCallToActionFragment\n        carouselAnalytics {\n          linkName\n          referrerId\n        }\n        beacons {\n          renderBeacons\n        }\n        link {\n          resource {\n            ... on HttpURI {\n              value\n            }\n          }\n          analytics {\n            urls\n          }\n          target\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
import React5 from "react";
import LazyLoad from "react-lazy-load";
import { gql as gql4, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { AdBlockDetectWrapper } from "@shared-ui/retail-sponsored-content-ad-block-detect-wrapper";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
// src/components/multi-listing-ad/__private/lazy-multi-listing-ad-content.tsx
import React4 from "react";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { IntersectionTimeTracker } from "@shared-ui/clickstream-analytics-context";
import { useBeaconsWrapper, useClickBeaconWrapper } from "@shared-ui/retail-sponsored-content-use-beacons-wrapper";
// src/components/multi-listing-ad/__private/analytics.ts
var getCarouselAnalyticsProp = function (carouselAnalytics, tracker) {
  var carouselAnalyticsProp = {};
  if (carouselAnalytics) {
    var analytics = {
      id: carouselAnalytics.referrerId,
      description: carouselAnalytics.linkName,
      callback: function (referrerId, linkName) {
        tracker(referrerId, linkName);
      }
    };
    carouselAnalyticsProp.analytics = analytics;
  }
  return carouselAnalyticsProp;
};
var getCallToActionAnalytics = function (analytics, tracker) {
  return {
    id: analytics.referrerId,
    description: analytics.linkName,
    callback: function (id, description) {
      return tracker(id, description, true);
    }
  };
};
var getInterSectionTimeTrackerProps = function (carouselAnalytics) {
  if (carouselAnalytics) {
    return {
      referrerId: "".concat(carouselAnalytics.referrerId, ".viewability"),
      linkName: carouselAnalytics.linkName,
      minTime: 1e3,
      // 1 secound
      intersectionOptions: {
        threshold: 0.3
      }
    };
  }
  return null;
};
// src/components/multi-listing-ad/__private/multi-listing-ad-call-to-action.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UILinkTargetMap } from "@shared-ui/lodging-fragments";
var fragment = gql(_templateObject());
var MultiListingAdCallToAction = function (param) {
  var data = param.data,
    onClickCallback = param.onClickCallback;
  var trackerEvent = useClickTracker();
  var callToAction = data.callToAction;
  var _callToAction_action = callToAction.action,
    accessibility = _callToAction_action.accessibility,
    resource = _callToAction_action.resource,
    target = _callToAction_action.target,
    analytics = _callToAction_action.analytics;
  var callToActionAnalytics = getCallToActionAnalytics(analytics, trackerEvent);
  var LINK_REL = "noopener noreferrer";
  var linkProps = {
    rel: LINK_REL,
    target: target && UILinkTargetMap[target]
  };
  return /* @__PURE__ */React.createElement(EGDSSpacing, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React.createElement(EGDSLink, {
    analytics: callToActionAnalytics,
    onClick: onClickCallback
  }, /* @__PURE__ */React.createElement("a", _object_spread_props(_object_spread({}, linkProps), {
    href: resource.value
  }), callToAction.text, !!accessibility && /* @__PURE__ */React.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility))));
};
MultiListingAdCallToAction.fragment = fragment;
MultiListingAdCallToAction.displayName = "MultiListingAdCallToAction";
// src/components/multi-listing-ad/__private/multi-listing-ad-carousel.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { LodgingCard, LodgingCardView } from "@shared-ui/lodging-fragments";
var fragment2 = gql2(_templateObject1(), LodgingCard.fragment);
var MultiListingAdCarousel = function (param) {
  var data = param.data,
    name = param.name,
    lodgingCardSelected = param.lodgingCardSelected;
  var _brandProperties_;
  var brandProperties = data.brandProperties,
    carouselAnalytics = data.carouselAnalytics;
  var trackClick = useClickTracker2();
  var className = "uitk-card-roundcorner-all uitk-card-has-primary-theme";
  var carouselAnalyticsProp = getCarouselAnalyticsProp(carouselAnalytics, trackClick);
  var gallery = brandProperties ? (_brandProperties_ = brandProperties[0]) === null || _brandProperties_ === void 0 ? void 0 : _brandProperties_.mediaSection.gallery : null;
  var carouselProps = _object_spread_props(_object_spread({}, carouselAnalyticsProp), {
    buttonText: {
      nextButton: (gallery === null || gallery === void 0 ? void 0 : gallery.nextButtonText) || "",
      prevButton: (gallery === null || gallery === void 0 ? void 0 : gallery.previousButtonText) || ""
    },
    navigationIconId: {
      next: "".concat(name, "-next"),
      prev: "".concat(name, "-prev")
    },
    carouselName: name,
    pageBy: 1,
    peek: true,
    itemsVisible: {
      xl: 2,
      lg: 2,
      md: 2,
      sm: 1
    },
    useContainerSizing: false,
    itemsMaxHeight: true
  });
  var getListingWithAnalytics = function (listing, index) {
    var updatedListing = _object_spread_props(_object_spread({}, listing), {
      impressionAnalytics: {
        referrerId: "".concat(carouselAnalytics === null || carouselAnalytics === void 0 ? void 0 : carouselAnalytics.referrerId, ".impression.").concat(index),
        linkName: carouselAnalytics === null || carouselAnalytics === void 0 ? void 0 : carouselAnalytics.linkName,
        url: null,
        uisPrimeMessages: [{
          schemaName: "hotelProduct",
          messageContent: '{ "productId": '.concat(listing.id, " }")
        }]
      }
    });
    return updatedListing;
  };
  return /* @__PURE__ */React2.createElement(EGDSCarousel, _object_spread({}, carouselProps), brandProperties === null || brandProperties === void 0 ? void 0 : brandProperties.map(function (listing, index) {
    return listing && /* @__PURE__ */React2.createElement(EGDSSpacing2, {
      key: "mla-".concat(listing.id),
      className: className
    }, carouselAnalytics && /* @__PURE__ */React2.createElement(LodgingCard, {
      data: getListingWithAnalytics(listing, index),
      view: LodgingCardView.COMPACT,
      onClickCallback: function () {
        return lodgingCardSelected === null || lodgingCardSelected === void 0 ? void 0 : lodgingCardSelected(listing.id);
      },
      border: true
    }), !carouselAnalytics && /* @__PURE__ */React2.createElement(LodgingCard, {
      data: listing,
      view: LodgingCardView.COMPACT
    }));
  }));
};
MultiListingAdCarousel.fragment = fragment2;
MultiListingAdCarousel.displayName = "MultiListingAdCarousel";
// src/components/multi-listing-ad/__private/multi-listing-ad-head.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSBadgeSize, EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSMark, EGDSMarkTokenSizesList } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSParagraph } from "@egds/react-core/text";
import { Transparency } from "@shared-ui/retail-sponsored-content-transparency";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var fragment3 = gql3(_templateObject2());
var MultiListingAdHead = function (param) {
  var data = param.data,
    onClickCallback = param.onClickCallback;
  var _logo_standard_url;
  var logo = data.logo,
    badge = data.badge,
    paragraph = data.paragraph,
    heading = data.heading,
    adTransparencyTrigger = data.adTransparencyTrigger;
  if (!(logo && paragraph && heading)) {
    return null;
  }
  var logoComponent = logo.standard && /* @__PURE__ */React3.createElement(EGDSMark, {
    url: (_logo_standard_url = logo.standard.url) === null || _logo_standard_url === void 0 ? void 0 : _logo_standard_url.value,
    size: EGDSMarkTokenSizesList[logo.standard.size || "5"],
    description: logo.standard.description
  });
  var headingComponent = /* @__PURE__ */React3.createElement(EGDSHeading, {
    tag: "h2",
    size: 5
  }, heading);
  var paragraphComponent = /* @__PURE__ */React3.createElement(EGDSParagraph, null, paragraph);
  var _badge_accessibility;
  var badgeComponent = (badge === null || badge === void 0 ? void 0 : badge.text) && /* @__PURE__ */React3.createElement(EGDSBadgeStandard, {
    text: badge.text,
    size: EGDSBadgeSize.SMALL,
    a11yText: (_badge_accessibility = badge.accessibility) !== null && _badge_accessibility !== void 0 ? _badge_accessibility : void 0
  });
  var TransparencyTriggerOrBadge = (adTransparencyTrigger === null || adTransparencyTrigger === void 0 ? void 0 : adTransparencyTrigger.adTransparencyButton) ? /* @__PURE__ */React3.createElement(Transparency, {
    data: adTransparencyTrigger
  }) : badgeComponent;
  return /* @__PURE__ */React3.createElement(Viewport, null, /* @__PURE__ */React3.createElement(ViewSmall, null, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    space: "three",
    wrap: "nowrap",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 0,
    alignSelf: "start"
  }, logoComponent), /* @__PURE__ */React3.createElement(EGDSSpacing3, {
    margin: {
      blockend: "two",
      blockstart: "two"
    }
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, headingComponent)), /* @__PURE__ */React3.createElement(EGDSSpacing3, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    minWidth: "full_width"
  }, paragraphComponent)))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 0,
    alignSelf: "start"
  }, TransparencyTriggerOrBadge))), /* @__PURE__ */React3.createElement(ViewMedium, null, /* @__PURE__ */React3.createElement(EGDSSpacing3, {
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    space: "three",
    wrap: "nowrap",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    maxWidth: 100
  }, logoComponent), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 4
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column",
    alignContent: "start"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    minWidth: "full_width"
  }, headingComponent), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    minWidth: "full_width",
    alignSelf: "start"
  }, /* @__PURE__ */React3.createElement(EGDSSpacing3, {
    margin: {
      blockstart: "half"
    }
  }, paragraphComponent)))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 0,
    alignSelf: "start"
  }, TransparencyTriggerOrBadge)))));
};
MultiListingAdHead.fragment = fragment3;
MultiListingAdHead.displayName = "MultiListingAdHead";
// src/components/multi-listing-ad/__private/lazy-multi-listing-ad-content.tsx
var LazyMultiListingAdContent = function (param) {
  var multiListingAd = param.multiListingAd,
    name = param.name,
    onCardClickCallback = param.onCardClickCallback;
  var _multiListingAd_link = multiListingAd.link,
    resource = _multiListingAd_link.resource,
    analytics = _multiListingAd_link.analytics;
  var clickBeaconWrapper = useClickBeaconWrapper();
  useBeaconsWrapper(multiListingAd.beacons);
  var onClickCallback = function () {
    var _analytics_urls;
    analytics === null || analytics === void 0 ? void 0 : (_analytics_urls = analytics.urls) === null || _analytics_urls === void 0 ? void 0 : _analytics_urls.forEach(function (url) {
      clickBeaconWrapper(url);
    });
    if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === "HttpURI" && resource.value) {
      clickBeaconWrapper(resource.value);
    }
  };
  var lodgingCardSelected = function (itemId) {
    onClickCallback === null || onClickCallback === void 0 ? void 0 : onClickCallback();
    onCardClickCallback === null || onCardClickCallback === void 0 ? void 0 : onCardClickCallback(itemId);
  };
  var multiListingAdContent = /* @__PURE__ */React4.createElement(EGDSSpacing4, {
    margin: {
      small: {
        blockstart: "six",
        blockend: "six"
      }
    },
    padding: {
      medium: {
        blockstart: "six",
        blockend: "six"
      }
    },
    border: {
      medium: ["blockstart", "blockend"]
    }
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(MultiListingAdHead, {
    data: multiListingAd,
    onClickCallback: onClickCallback
  }), /* @__PURE__ */React4.createElement(MultiListingAdCarousel, {
    data: multiListingAd,
    name: name,
    lodgingCardSelected: lodgingCardSelected
  }), /* @__PURE__ */React4.createElement(MultiListingAdCallToAction, {
    data: multiListingAd,
    onClickCallback: onClickCallback
  })));
  var intersectionTimeTrackerProps = getInterSectionTimeTrackerProps(multiListingAd.carouselAnalytics);
  return intersectionTimeTrackerProps ? /* @__PURE__ */React4.createElement(IntersectionTimeTracker, _object_spread({}, intersectionTimeTrackerProps), " ", multiListingAdContent, " ") : multiListingAdContent;
};
LazyMultiListingAdContent.displayName = "LazyMultiListingAdContent";
// src/components/multi-listing-ad/multi-listing-ad.tsx
var __Query = gql4(_templateObject3(), MultiListingAdCarousel.fragment, MultiListingAdHead.fragment, MultiListingAdCallToAction.fragment);
var MultiListingAdComponent = function (props) {
  var _multiListingAd_brandProperties;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    name = props.name,
    onCardClickCallback = props.onCardClickCallback;
  var context = useBexApi().context;
  var _React5_useState = _sliced_to_array(React5.useState(0), 2),
    lazyOffset = _React5_useState[0],
    setLazyOffset = _React5_useState[1];
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  React5.useEffect(function () {
    setLazyOffset(window.innerHeight);
  }, []);
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr,
      fetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error) {
    return null;
  }
  var multiListingAd = data === null || data === void 0 ? void 0 : data.sponsoredContent.multiListingAd;
  if (!(multiListingAd === null || multiListingAd === void 0 ? void 0 : (_multiListingAd_brandProperties = multiListingAd.brandProperties) === null || _multiListingAd_brandProperties === void 0 ? void 0 : _multiListingAd_brandProperties.length)) {
    return null;
  }
  return /* @__PURE__ */React5.createElement(Viewport2, null, /* @__PURE__ */React5.createElement(ViewSmall2, null, /* @__PURE__ */React5.createElement(LazyLoad, {
    offset: lazyOffset
  }, /* @__PURE__ */React5.createElement(LazyMultiListingAdContent, {
    multiListingAd: multiListingAd,
    name: name,
    onCardClickCallback: onCardClickCallback
  }))), /* @__PURE__ */React5.createElement(ViewMedium2, null, /* @__PURE__ */React5.createElement(LazyLoad, {
    offset: lazyOffset / 2
  }, /* @__PURE__ */React5.createElement(LazyMultiListingAdContent, {
    multiListingAd: multiListingAd,
    name: name,
    onCardClickCallback: onCardClickCallback
  }))));
};
MultiListingAdComponent.displayName = "sharedui-MultiListingAdComponent";
var MultiListingAd = AdBlockDetectWrapper(MultiListingAdComponent);
MultiListingAd.displayName = "sharedui-MultiListingAd";
export { MultiListingAd };